export default "__VITE_ASSET__fcfa464a__"